module.exports = "/_next/static/images/42afb44f9a5880ca269e1a5dced3555e-rewards-hosting@1x.png.webp";